import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

export enum PostMessageType {
    stateChanged = 0,
    initialized = 1,
}

export class PostMessage {
    // data members

    data: any;
    type: any;
    exception: any;

    // constructors

    constructor(data: any, type: PostMessageType, exception: any = null) {
        this.data = data;
        this.type = type;
        this.exception = exception;
    }
}

@Injectable()
export class PostMessageService implements OnDestroy {
    // events

    eventReceived = new EventEmitter<PostMessage>();

    // constructor

    constructor() {
        window.addEventListener('message', this.handleMessage, false);
    }

    // public functions

    ngOnDestroy() {
        window.removeEventListener('message', this.handleMessage);
    }

    send(postMessage: PostMessage, targetOrigin = '*') {
        window.parent.postMessage(JSON.stringify(postMessage), targetOrigin);
    }

    // private functions

    private handleMessage = (message: MessageEvent) => {
        if (message.data.type == 'PostMessage') {
            let postMessage = JSON.parse(message.data) as PostMessage;
            this.eventReceived.emit(postMessage);
        }
    };
}
